import { render } from "./SliderComponent.vue?vue&type=template&id=6b50397c&scoped=true"
import script from "./SliderComponent.vue?vue&type=script&lang=js"
export * from "./SliderComponent.vue?vue&type=script&lang=js"

import "./SliderComponent.vue?vue&type=style&index=0&id=6b50397c&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b50397c"]])

export default __exports__